import React from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import Icons from '../components/layouts/Icons';
import BoxedContainer from '../components/layouts/BoxedContainer';

export default function PlainBanner({ data }) {
  const { title, text, isVenue, bgWhite } = data;

  return (
    <section
      className={`lg:h-[741px] h-[550px] w-full lg:pt-[290px] ${bgWhite ? 'bg-white' : 'bg-bg-1'}`}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.8 }}
        className="flex flex-col items-center w-full lg:pt-0 pt-[12rem]"
      >
        <BoxedContainer className="regular">
          <div className="flex flex-col justify-center items-center h-full w-full">
            <div
              className={`text-center flex flex-col items-center 2xl:gap-y-[90px] gap-y-[70px]
              ${isVenue ? 'lg:w-[80%]' : 'lg:w-[55%]'}`}
            >
              {isEmpty(title) || (
                <h1
                  className="flex flex-col font-roboto-condensed-bold uppercase leading-[1.5]
                  text-black lg:tracking-[11px] tracking-[3px] relative before:content-['']
                  before:!inline before:absolute before:lg:-bottom-10 before:-bottom-[45px]
                  before:left-1/2 before:h-10 before:w-[2px] before:bg-black"
                  style={{
                    fontSize: 'clamp(2.5rem, 2.439vw + 2.073rem, 5rem)',
                  }}
                >
                  {title}
                </h1>
              )}

              {isEmpty(text) || (
                <p
                  className="text-black leading-[1.75]
                  font-roboto-regular text-center 2xl:max-w-[633px] max-w-[500px] flex flex-col
                  lg:gap-y-4 gap-y-3 items-center lg:px-6"
                  style={{
                    fontSize: 'clamp(0.875rem, 0.244vw + 0.832rem, 1.125rem)',
                  }}
                >
                  {text}
                  <Icons icon="black-down-arrow" className="!block w-[12px]" />
                </p>
              )}
            </div>
          </div>
        </BoxedContainer>
      </motion.div>
    </section>
  );
}
